import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing086({ urlCode, urlCodeSettingId }) {
  const treatments = [{ value: "aa89d765-b156-4fc8-8ce4-ad854d8c3bf9", label: "MFT세미나" }];
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/086/25020301.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/086/25020302.png`}
      benefitInfoPosition="top"
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/ApplyBenefitButton2.png`}
      companyName="검단뉴욕치과의원"
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan2.jpg`}
      treatments={treatments}
    />
  );
}

export default Randing086;
